import { titleCase } from '../lib/format';

// Maps a resource/provider status to a semantic color tone.
const TONE = {
  running: 'ok',
  operational: 'ok',
  available: 'ok',
  provisioning: 'info',
  limited: 'warn',
  degraded: 'warn',
  maintenance: 'warn',
  stopped: 'muted',
  error: 'danger',
  critical: 'danger',
  warning: 'warn',
  info: 'info',
};

export default function StatusBadge({ status }) {
  const tone = TONE[status?.toLowerCase()] || 'muted';
  return (
    <span className={`badge badge--${tone}`}>
      <span className="badge__dot" />
      {titleCase(status || 'unknown')}
    </span>
  );
}
